<template>
  <div class="hvh-chart" v-resize="onResize" :visualization="visualization" :style="{ height }" @wheel="$emit('wheel', $event)"></div>
</template>

<script>
import { merge } from 'lodash';

import ChartServiceFactory from '../../libraries/charts/ChartServiceFactory';
import { Debouncer } from '../../libraries/common';
// import ChartService from '../../libraries/charts/ChartService';

export default {
  props: ['visualization', 'options', 'height', 'isEditMode'],
  data() {
    return {
      chartInstance: null,
      debounce: new Debouncer(250),
    };
  },
  computed: {
    chartService() {
      return ChartServiceFactory.create(this.visualization.visualization_type);
    },
    chartData() {
      const chartData = merge(
        this.chartService.buildChartData(
          this.visualization,
          this.isEditMode,
          this.$el.getBoundingClientRect()
        ),
        this.options
      );
      this.$emit('dataCreated', chartData);
      return chartData;
    },
  },
  methods: {
    renderChart() {
      this.chartInstance = this.chartService.render(this.$el, this.chartData);
      this.chartInstance.off('click', this.itemClicked);
      this.chartInstance.on('click', this.itemClicked);
      this.chartInstance.on('dataZoom', this.dataZoomed);
      this.chartInstance.off('dragnode', this.nodeDragged);
      this.chartInstance.on('dragnode', this.nodeDragged);

      if (this.visualization.onRender) {
        this.chartInstance.off('rendered', this.visualization.onRender);
        this.chartInstance.on('rendered', this.visualization.onRender);
      }
      this.$emit('chart-rendered', this.chartInstance);
    },
    nodeDragged(event) {
      this.$emit('drag-node', {
        node: this.visualization.data.nodes[event.dataIndex],
        localX: event.localX,
        localY: event.localY,
      });
    },
    resizeChart() {
      if (!this.chartInstance) {
        return;
      }

      this.chartInstance.resize({
        height: this.$el.clientHeight,
        width: this.$el.clientWidth,
      });
    },
    itemClicked(event) {
      if (event.data.data != null) {
        this.$emit('item-clicked', event.data.data, event);
      } else if ((this.visualization.data || {})[event.seriesName]) {
        this.$emit('item-clicked', event.dataIndex, this.visualization.data[event.seriesName]);
      } else { this.$emit('item-clicked', event.data); }
    },
    dataZoomed(event) {
      this.$emit('data-zoomed', event);
    },
    onResize() {
      this.debounce.clear().push(this.resizeChart);
    },
  },
  mounted() {
    this.renderChart();
    this.$nextTick(this.resizeChart);
  },

  updated() {
    this.renderChart();
  },
}
</script>

<style lang="scss">
.hvh-chart {
  height: 550px;
  width: 100%;
}

.hvh-chart-horizontal {
  display: inline-block;
  width: calc(100% - 25px);
}
</style>
